// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__gqPf9","label":"Section_label__7ZwNX","contentWrap":"Section_contentWrap__2oWW-","footer":"Section_footer__30hP-","footerInner":"Section_footerInner__J69Gq"};